import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
  Label,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const NtpEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  let formError = false;

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);

  const [selectedDevices, setSelectedDevices] = useState(
    location.state ? location.state.value : ""
  );

  // Object containing all the form values
  const [ntpValues, setNtpValues] = useState({
    mode: false,
    server1: "",
    server2: "",
    server3: "",
    server4: "",
    server5: "",
  });

  // Object containing all error messages for every inputs
  const [ntpStates, setNtpStates] = useState({
    mode: "",
    server1: "",
    server2: "",
    server3: "",
    server4: "",
    server5: "",
  });

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.timezones.ntp.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    if (!formError) {
      postData();
    }
  };

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Call the API
    fetch("/api/v1/timezones/ntp/edit", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        mode: ntpValues.mode,
        server1: ntpValues.server1,
        server2: ntpValues.server2,
        server3: ntpValues.server3,
        server4: ntpValues.server4,
        server5: ntpValues.server5,
        selectedDevices: selectedDevices,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while changing the NTP server", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("NTP server saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNtpValues({
      ...ntpValues,
      [name]: value,
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/timezones/list",
                      }}
                    >
                      Timezones
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>NTP Edit</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">NTP Configuration</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <p>Selected Devices: {selectedDevices.join(", ")}</p>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>Server #1</label>
                      <FormGroup
                        className={
                          ntpStates["server1"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          type="server1"
                          name="server1"
                          onChange={handleInputChange}
                          value={ntpValues.server1}
                        />
                        <label className="error">{ntpStates["server1"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Server #2</label>
                      <FormGroup
                        className={
                          ntpStates["server2"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          type="server2"
                          name="server2"
                          onChange={handleInputChange}
                          value={ntpValues.server2}
                        />
                        <label className="error">{ntpStates["server2"]}</label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Server #3</label>
                      <FormGroup
                        className={
                          ntpStates["server3"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          type="server3"
                          name="server3"
                          onChange={handleInputChange}
                          value={ntpValues.server3}
                        />
                        <label className="error">{ntpStates["server3"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Server #4</label>
                      <FormGroup
                        className={
                          ntpStates["server4"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          type="server4"
                          name="server4"
                          onChange={handleInputChange}
                          value={ntpValues.server4}
                        />
                        <label className="error">{ntpStates["server4"]}</label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Server #5</label>
                      <FormGroup
                        className={
                          ntpStates["server5"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          type="server5"
                          name="server5"
                          onChange={handleInputChange}
                          value={ntpValues.server5}
                        />
                        <label className="error">{ntpStates["server5"]}</label>
                      </FormGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NtpEdit;
